import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider } from '@emotion/react';
import Theme from './theme';
export default (props) => _jsx(ThemeProvider, { theme: Theme, children: props.children });
//# sourceMappingURL=theme_provider.js.map